export const getToken = (state) => state.session.accessToken;
export const getBankId = (state) => state.session.bankId;
export const getClientContext = (state) => state.session.clientContext;
